module.exports = __webpack_public_path__ + "img/package.ab5bed19.svg";